import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=15c71810&scoped=true&lang=html&"
import script from "./ProductDetails.vue?vue&type=script&lang=ts&"
export * from "./ProductDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=15c71810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c71810",
  null
  
)

export default component.exports